<template>
    <div class="maincontainer" v-observe-visibility="visibilityChange">
        <div id="unresolveDialog" class="modal">
            <div class="modal-content">
                <p style="text-align: left;" v-html="$t('place.change_to_question', {changeto: $t('recommendations.pending')})"></p>
            </div>
            <div class="modal-footer">
                <button class="modal-close waves-effect waves-green btn-flat btn-small cancelbutton">{{$t('menu.buttons.cancel')}}</button>
                <button class="modal-close waves-effect waves-green btn-flat btn-small green" v-on:click="unresolve(selectedreco)">Zmień</button>
            </div>
        </div>
        <div id="resolveDialog" class="modal">
            <div class="modal-content">
                <p style="text-align: left;" v-html="$t('place.change_to_question', {changeto: $t('recommendations.resolved')})"></p>
            </div>
            <div class="modal-footer">
                <button class="modal-close waves-effect waves-green btn-flat btn-small cancelbutton">{{$t('menu.buttons.cancel')}}</button>
                <button class="modal-close waves-effect waves-green btn-flat btn-small green" v-on:click="resolve(selectedreco)">Zmień</button>
            </div>
        </div>
        <div class="row">
            <div class="col s10 label" style="margin-bottom: 15px;">
                <label>
                    <input type="checkbox" v-model="show_resolved"/>
                    <span>{{$t('menu.buttons.show_resolved')}}</span>
                </label>
            </div>
            <div class="col s2" style="margin-bottom: 15px;">
                 <a :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/recommendations'+ (show_resolved  ? '/all' : '' )+'.pdf'" class="modal-close waves-effect waves-green btn-flat btn-small green">{{$t('menu.buttons.download_pdf')}}</a>
            </div>
        </div>
        <button v-on:click="show_timeline = true" title="Pokaż diagram" class="modal-close waves-effect waves-green btn-flat btn-small green"><i class="material-icons dp48">sort</i></button>
        <div v-show="show_timeline">
            <div class="row">
              <div class="col s3 input-field" style="padding-left: 0px;padding-right: 5px; min-width: 13ch; padding-top: 15px;">
                <input type="date" v-model="from"/>
              </div>
              <div class="col s3 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch; padding-top: 15px;">
                <input type="date" v-model="to"/>
            </div>
             <div class="col s3 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch; padding-top: 15px;">
                <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
              </div>
            </div>
            <div ref="canvasframe" style="min-height: 50px;">
                <canvas ref="canvas"></canvas>
            </div>
        </div>
        <template v-for="(recommendation, index) in listItems">
            <div style="border-style: groove;margin-top: 15px;margin-bottom: 15px;">
                    <div class="row" style="padding-top: 1em; ">
                        <div class="col s2 l2">
                            <autosizelabel :text='$t("recommendations.number")' />
                            <div class="input-field">
                                <input v-model="recommendation.number" disabled>
                            </div>
                        </div>
                         <div class="col xs7 l8">
                        <autosizelabel :text='$t("recommendations.problem_found")' />
                            <div class="input-field">
                                <input v-model="recommendation.about" :disabled="!editing">
                            </div>
                        </div>
                        <div class="col xs3 l2" style="text-align: end;">
                           <a class="waves-effect waves-light btn-large emptygreen modal-trigger" v-if="recommendation.status == 'resolved'" v-on:click="selectedreco = recommendation" href="#unresolveDialog">{{$t("recommendations.resolved")}}</a>
                           <a class="waves-effect waves-light btn-large emptyred modal-trigger" v-if="recommendation.status == 'unresolved'" v-on:click="selectedreco = recommendation" href="#resolveDialog">{{$t("recommendations.pending")}}</a>
		           <a class="" v-if="recommendation.status == 'resolved'"  :href="'/customers/'+customer_id+'/places/'+place_id+'/recommendations/'+recommendation.id+'.pdf'"><span data-v-2a5bcde8="" class="material-icons dp6">featured_play_list</span></a>                               </div>
                        
                    </div>
                    <div class="row">
                    
                        <div class="col s3 l3">
                            <autosizelabel :text='$t("recommendations.date")' />
                            <div class="input-field">
                                <input v-model="recommendation.date" disabled>
                            </div>
                        </div>
                            <div class="col s3 l3">
                            <autosizelabel :text='$t("recommendations.type")' />
                            <div class="input-field">
                                <select class="browser-default" v-model="recommendation.kind" :disabled="!editing">
                                    <option value="correction">{{$t("recommendations.correction")}}</option>
                                    <option value="fixing">{{$t("recommendations.repairs")}}</option>
                                    <option value="prevention">{{$t("recommendations.prevention")}}</option>
                                    <option value="emergency">{{$t("recommendations.emergency")}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col s6 l6">
                            <autosizelabel :text='$t("recommendations.responsible")' />
                            <div class="input-field">
                                <input v-model="recommendation.responsible" :disabled="!editing">
                            </div>
                        </div>
                       
                        <div class="col s6 l6">
                            <autosizelabel :text='$t("recommendations.cause")' />
                            <div class="input-field">
                                <input v-model="recommendation.cause" :disabled="!editing">
                            </div>
                        </div>
                        <div class="col s6 l6">
                            <autosizelabel :text='$t("recommendations.recommended_solution")' />
                            <div class="input-field">
                                <input v-model="recommendation.solution" :disabled="!editing">
                            </div>
                        </div>
                       
                        
                        
                    </div>
                </div>
        </template>
        <preloader v-if="loaded == false" n="7" />
        <div class="row" style="padding-top: 25px;">
            <div class="col  offset-l8 s4 l2">
                <a v-on:click="cancelEdit()" class="waves-effect waves-light btn-large cancelbutton" v-if="editing == true">{{$t('menu.buttons.cancel_changes')}}</a>
            </div>
            <div class="col l2 s4">
                <a v-on:click="edit()" class="waves-effect waves-light btn-large emptygreen" v-if="editing == false && editable">{{$t('menu.buttons.edit')}}</a>
                <a v-on:click="save_changes()" class="waves-effect waves-light btn-large green" v-if="editing">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import Vue2Filters from 'vue2-filters';
import Chart from 'chart.js'
import {
  TimelineController,
  TimelineElement
} from 'chartjs-chart-timeline'
import axios from 'axios';
import moment from 'moment';
export default {
    data: function() {
        return {
            order: 'asc',
            orderby: 'date',
            places: [],
            loaded: false,
            saving: false,
            show_timeline: false,
            datacollection: [],
            devcats: {},
            visible: false,
            editing: false,
            show_resolved: false,
            inspections: [],
            from: moment().subtract(1, 'year').format("YYYY-MM-DD"),
            to: moment().format("YYYY-MM-DD"),
            kinds: [
                { name: "Korygujące", value: "correction" },
                { name: "Naprawcze", value: "fixing" },
                { name: "Zapobiegawcze", value: "prevention" },
                { name: "Awaryjne", value: "emergency" }
            ],
            selected_kinds: [],
            recommendations: [],
            old_recommendations: [],
            chart: undefined
        }
    },
    props: { customer_id: [String, Number], place_id: [String, Number], inspection_id: [String, Number], editable: Boolean, split: Boolean},
    async created() {
        await this.fetch_places();
        this.renderGraph();
    },
    mounted: function() {
      var elems = this.$el.querySelectorAll('.modal');
      this.instances = M.Modal.init(elems, {});

    },
    methods: {
        fetch_places: async function() {
            if (this.place_id != 0 && this.place_id != undefined) {
                var response = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/recommendations/v2.json')
                this.recommendations = response.data;
                var resp = await axios.get('/customers/' + this.customer_id + '/places/' + this.place_id + '/inspections.json')
                this.inspections = resp.data;
                this.loaded = true
            }else{

                var response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/'+this.$route.params.inspection_id+'/recommendations.json')
                this.recommendations = response.data;
                this.loaded = true
            }
            
        },
         
        save_changes: async function() {
            var response = await axios.post('/customers/' + this.customer_id + '/places/' + this.place_id + '/recommendations/multiple_recommendations_update.json', { "recommendations": { "updates": _.keyBy(this.recommendations, 'id') } })
            // this.recommendations = response.data;
            this.editing = false
        },
        edit: function() {
            this.old_recommendations = _.cloneDeep(this.recommendations)
            this.editing = true
        },
        cancelEdit: function() {
            this.recommendations = _.cloneDeep(this.old_recommendations)
            this.editing = false
        },
        applyChanges: function(){
            this.renderGraph();
        },
        renderGraph: function(){
            const chartData = this.buildTimelineChartData(
                this.recommendations,
                []
              )
            console.log(chartData.labels, chartData);
            this.$refs.canvasframe.style.height = ((chartData.labels.length * 30) + 80) + 'px'
            this.$refs.canvas.style.height = (chartData.labels.length * 60) + 'px'
            var that = this
            if (this.chart) {
              this.chart.destroy();
            }
            this.chart = new Chart(this.$refs.canvas, {
                "type": "timeline",
               
                "options": {
                    "tooltips": {
                        "callbacks": {
                            label: function(item, data) {
                            const dataset =
                              data.datasets[item.datasetIndex]
                            console.log(dataset.data[item.index]);
                            const row =
                              dataset.data[item.index]

                            const from = row[0]
                            const to = row[1]

                            const meta = row[3]

                            const days =
                              Math.round(
                                (
                                  new Date(to) -
                                  new Date(from)
                                ) / 86400000
                              )
                            if(meta == undefined){
                                return [
                                    `Kontrola ${moment(from).format("D MMMM YYYY")}`
                                ]
                            }
                            return [
                              `Typ działania: ${that.name_kinds(meta.kind)}`,
                              `Zgłoszono: ${moment(from).format("D MMMM YYYY")}`,
                              `Rozwiązano: ${moment(to).format("D MMMM YYYY")}`,
                              `Rozwiązanie: ${meta.solution || '-'}`
                            ]
                          }
                        }
                    },
                    "showText": false,
                    "maintainAspectRatio": false,
                    "colorFunction": function(
                      text,
                      data,
                      dataset,
                      index
                    ) {
                      switch(dataset.kind) {
                        case 'correction':
                          return Color('#fb8c00')

                        case 'fixing':
                          return Color('#1e88e5')

                        case 'prevention':
                          return Color('#43a047')

                        case 'emergency':
                          return Color('#e53935')

                        default:
                          return Color('#757575')
                      }
                    }
                },
                "data": chartData
              }
            )
        },
        unresolve: function(reco) {
            if (this.editing == false) {
                this.edit()
            }
            reco.status = 'unresolved'
        },
        resolve: function(reco) {
            if (this.editing == false) {
                this.edit()
            }
            reco.status = 'resolved'
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },

        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 'desc') {
                    this.order = 'asc'
                } else if (this.order == 'asc') {
                    this.order = 'desc'
                }

            } else {
                this.orderby = order;
            }
        },
        visibilityChange(evt, hidden) {
            this.visible = evt;
        },
        name_kinds: function(kind) {
            var out = ""
            out += { "correction": "Korygujące", "fixing": "Naprawcze", "prevention": "Zapobiegawcze", "emergency": "Awaryjne" } [kind] + " "

            return out;
        },
        buildTimelineChartData: function(
              recommendations,
              meetings
            ) {
              const labels = [
                'Kontrole'              ]

              const datasets = []
              var that = this;
              // meetings dataset
              datasets.push({
                label: 'Kontrole',

                data: _.filter(this.inspections, function(insp){
                    return moment(insp.date).isAfter(moment(that.from)) && moment(insp.date).isBefore(moment(that.to));
                }).map(meeting => ([
                  meeting.date,

                  // tiny interval so marker is visible
                  new Date(
                    new Date(meeting.date).getTime() + 60 * 60 * 1000
                  ),

                  meeting.name || 'Kontrola'
                ]))
              })

              // recommendation datasets
              this.recommendations.forEach(recommendation => {
                var ds = {
                  kind: recommendation.kind,
                  label: recommendation.about,
                  borderWidth: 1,
                  data: _.filter(recommendation.recommendation_openeds, function(ro){
                    return moment(ro.from).isAfter(moment(that.from))
                  }).map(opened => ([
                    opened.from,
                    opened.to,
                    recommendation.about,
                    recommendation
                  ]))
                };
                if(ds.data.length > 0){
                    labels.push(recommendation.about);
                    datasets.push(ds)
                }
              })

              return {
                labels,
                datasets
              }
            },
    },
    computed: {
        listItems() {
            var that = this;
            return _.filter(
                _.orderBy(this.recommendations, (p) => moment(p.date, "DD-MM-YYYY"), ['desc']).reverse(),
                function(item) {
                    return (_.intersection(that.selected_kinds, item.types).length > 0 || that.selected_kinds.length == 0) && (that.show_resolved || item.status == 'unresolved')
                }
            );
        },
        lastInspection: function() {
            var inps = _.last(_.orderBy(this.recommendations, 'date'));
            if (_.isUndefined(inps) == false)
                return inps.date;
            return "-"
        }
    },
    mixins: [Vue2Filters.mixin],
}
</script>
<style scoped>
.maincontainer {
    text-align: left;
}

p {
    font-size: 2em;
    text-align: center;
}

thead th {
    font-weight: 300;
}

thead .input-field {
    margin-top: unset;
    margin-bottom: unset;
}

select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.btn-large /deep/ {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/deep/ .emptygreen {
    background-color: #FFF !important;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
}

.row .col div {
    display: flex;
    max-height: 60px;
}
input, select {
    font-size: 12px;
}

.emptyred {
    border-color: #c22026;
}
.btn-large{
    padding-left: 5px !important;
    padding-right: 5px !important;
}
</style>
